import {
  Popover,
  PopoverBody,
  PopoverArrow,
  PopoverTrigger,
  PopoverContent,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { useColorValue } from '~/hooks';

import type { PromptProps } from './types';

export const DesktopPrompt = (props: PromptProps): JSX.Element => {
  const { trigger, children, ...disclosure } = props;
  const bg = useColorValue('white', 'gray.900');

  return (
    <Popover closeOnBlur={false} {...disclosure}>
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <PopoverContent bg={bg} w="sm" maxW="calc(100vw - 2rem)">
        <PopoverArrow bg={bg} />
        <PopoverCloseButton />
        <PopoverBody p={6} maxH="min(70vh, 32rem)" overflowY="auto">
            {children}
          </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
